if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Auto select
         * Automatically select an option, given a specific value for @input
         * - mandatory attribute data-autoselect-statement=input_value:#id_of_target=value_of_target
         */
        ZZ.AutoSelect = function(input) {
            var base = this;
            base.input = input;

            var statementFormatRegEx = /.+:.+=.+/;
            var fullStatement = base.input.attr("data-autoselect-statement");
            if (!statementFormatRegEx.test(fullStatement)) {
                throw new Error(
                    "[autoselect.js] ZZ.AutoSelect - format of statement is incorrect; expected: data-autoselect-statement=input_value:#id_of_target=value_of_target"
                );
            }

            var statement = fullStatement.split(":");
            var targetAndValue = statement[1].split("=");
            base.checkValue = statement[0];
            base.target = $(targetAndValue[0]);
            base.autoValue = targetAndValue[1];
            base.rememberValue = base.target.val();

            base.assignListeners();
        };

        ZZ.AutoSelect.prototype = {
            assignListeners: function() {
                var base = this;

                base.input.on("change", function() {
                    if (base.input.val() === base.checkValue) {
                        base.autoSelectTarget();
                    } else {
                        base.resetTarget();
                    }
                });
            },

            autoSelectTarget: function() {
                var base = this;

                base.rememberValue = base.target.val();
                base.target.val(base.autoValue);
                base.target.prop("disabled", true);
                base.target.addClass("disabledByAutoSelect");
            },

            resetTarget: function() {
                var base = this;

                base.target.removeClass("disabledByAutoSelect");
                if (base.target.hasClass("disabledBy")) {
                    base.target.prop("disabled", false);
                }
                base.target.val(base.rememberValue);
            }
        };
    })(jQuery);
}
